import backend from '@common/backend';

import { CreateProgramData } from '../types/programs';

const BASE = '/programs';

export interface IGetProgramsQuery {
	search?: string;
	page?: number;
	limit?: number;
	services_ids?: number[];
	service_id?: number;
	study_direction?: string;
}

export const programFromBE = (program: any) => ({
	// @TODO: Remove when BE will be fixed
	...program,
	service: program.service_id,
	service_template: program.service_template_id,
});

export const getPrograms = (query: IGetProgramsQuery) =>
	backend.get(BASE, { params: query }).then((programs: any) => programs.map(programFromBE));

export const postProgram = (data: CreateProgramData) => backend.post(BASE, data);

export const showProgram = (programId: number) =>
	backend.get(`${BASE}/${programId}`).then(programFromBE);

export const updateProgram = async (program_id: number, data?: any) =>
	backend.post(`${BASE}/${program_id}`, data).then(programFromBE);

export const deleteProgram = async (id: number) => backend.delete(`${BASE}/${id}`);

export const invertPublished = async (id: number, data?: any) =>
	backend.put(`${BASE}/invertPublished/${id}`, data);

export const getProgramBooks = (program_id: number, query?: IGetProgramsQuery) =>
	backend.get(`${BASE}/${program_id}/books`, { params: query });

export const attachProgramBooks = async (program_id: number, data?: any) =>
	backend.patch(`${BASE}/${program_id}/books`, data);

export const generateLessons = async (id: number, data?: any) =>
	backend.put(`${BASE}/generate/${id}`, data);

export const cloneProgram = (programId: number, serviceId: number) =>
	backend.post(`${BASE}/cloning/${programId}/${serviceId}`, {});
